import {StageLayer} from "@nolimitcity/slot-launcher/bin/StageLayer";
import {NolimitApplication} from "@nolimitcity/slot-launcher/bin/NolimitApplication";
import {ScreenBounds} from "@nolimitcity/slot-launcher/bin/display/ScreenBounds";
import {TimelineLite} from "gsap";

export class TheBorderBlackOverlayView extends PIXI.Container implements StageLayer {
    private _blackOverlay: PIXI.Graphics;

    constructor() {
        super();
        this.name = "TheBorderBlackOverlayView";
        this.init();
    }

    public onResize(): void {
        this.updateOverlay();
    }

    public toggleOverlay(on: boolean, toAlpha: number, duration: number): TimelineLite {
        const tl: TimelineLite = new TimelineLite();

        if (!this._blackOverlay) {
            return tl;
        }

        if (on) {
            this._blackOverlay.alpha = 0;
            this._blackOverlay.visible = on;
        }

        tl.to(this._blackOverlay, {
            duration: duration,
            alpha: toAlpha,
            onComplete: () => {
                if (!on) {
                    this._blackOverlay.visible = false;
                }
            }
        });

        return tl;
    }

    private init() {
        this._blackOverlay = new PIXI.Graphics();
        this._blackOverlay.visible = false;
        this.updateOverlay();
        this.addChild(this._blackOverlay);
    }

    private updateOverlay(): void {
        const bounds: ScreenBounds = NolimitApplication.screenBounds;

        this._blackOverlay.clear();
        this._blackOverlay.beginFill(0x000000, 1);
        this._blackOverlay.drawRect(bounds.left, bounds.top, bounds.width, bounds.height);
        this._blackOverlay.endFill();
    }
}